import React, { ReactNode } from "react";
import styled from "styled-components";

interface FileInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  children?: ReactNode;
}

const StyledLabel = styled.label`
  display: inline-flex;
  position: relative;
`;

const HiddenInput = styled.input`
  bottom: 0;
  cursor: pointer;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const FileInput = ({ className, children, ...rest }: FileInputProps) => (
  <StyledLabel className={className}>
    {children}
    <HiddenInput type="file" {...rest} />
  </StyledLabel>
);
